import { UseQueryOptions } from '@tanstack/react-query';

import { VoiceCallContent } from 'domains/content/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths } from 'models/enums';
import { PathWithID } from 'models/types';

import QueryKeys from './keys';

type UseVoiceContentParams = {
    voiceContentId?: string;
    reactQueryOptions?: UseQueryOptions<VoiceCallContent, Error>;
};

const useVoiceContentById = ({ voiceContentId, reactQueryOptions }: UseVoiceContentParams) =>
    useQuery<VoiceCallContent>(
        QueryKeys.VOICE_CONTENT_ID(Number(voiceContentId)),
        `${new PathWithID(CuredApiPaths.VOICE_CONTENT, voiceContentId).url}`,
        reactQueryOptions
    );

export default useVoiceContentById;
